import { render, staticRenderFns } from "./NotificationItems.vue?vue&type=template&id=44f2cf72"
import script from "./NotificationItems.vue?vue&type=script&lang=js"
export * from "./NotificationItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports